import React, { Component } from 'react';
import { TextInput } from '../components/TextInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import axios from 'axios';

interface IProps {
    gtmEvent(): void;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    email?: string;
    name?: string;
    status: 'open'|'subscribing'|'subscribed';
}

export class SubscribeNewsletter extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {status: 'open', hasError: false};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    submit() {
        var errors:string[]=[];
        if (!this.state.email) {
            errors.push("Email is required");
        }
        if (!this.state.name) {
            errors.push("Name is required");
        }
        if (errors.length > 0) {
            this.setState({errors: errors, hasError: true});
            return;
        }
        var nameParts:string[] = this.state.name.split(' ');
        var firstName = nameParts[0];
        var lastName = nameParts.slice(1).join(' ');
        var lead:any = {firstNameApplicant1: firstName, surnameApplicant1: lastName, emailApplicant1: this.state.email};
        
        this.setState({status: 'subscribing'});
        axios.post("/lead/subscribe", lead)
        .then((response) => {
            this.setState({status: 'subscribed'});
        })
        .catch((error) => {
            //alert('submit error: ' + error.message);
        });
    }

    render() {

        return (
            <header className="App-header bgchartreuse">
                <h1 className='l'>The latest, to your letterbox</h1>
                {this.state.status === 'open' &&
                <>
                <p>Subscribe to our newsletter to stay up to date with mortgage tips, customer stories, and so much more!</p>
                <div className='wrapper'>
                    <div className='row justify-c'>                    
                        <div className={`column3`}>
                            <TextInput
                                id='name'
                                value={this.state.name}
                                placeholder='Name'
                                classes={`${this.state.hasError && !this.state.name ? "e" : ""} tight`}
                                onChange={(e) => { this.setState({name: e.target.value}); }} />

                        </div>
                        <div className='column3'>
                            <TextInput
                                id='email'
                                value={this.state.email}
                                placeholder='Email Address'
                                classes={`${this.state.hasError && !this.state.email ? "e" : ""} tight`}
                                onChange={(e) => { this.setState({email: e.target.value}); }} />
                        </div>
                        <NextButton customLabel='Submit' type='tertiary' onClick={() => this.submit()} />
                    </div>
                    {this.state.hasError &&
                        <ErrorBox hideTitle={true} errors={this.state.errors!} />
                    }
                </div>
                </>
                }
                {this.state.status === 'subscribing' &&
                <div className='loading-spinner-nodelay'/>
                }
                {this.state.status === 'subscribed' &&
                <p>Thank you for subscribing!</p>
                }
            </header>
        );
    }
}
